<template>
  <div class="row">
    <div class="col-sm-12 col-md-4">
      <EducationSystemSelect
        @setEducationSystem="parameters.education_system_id = $event; setParameters()"
      />
    </div>
    <div class="col-sm-12 col-md-4">
      <EducationStageSelect
        :education-system-id="parameters.education_system_id"
        @setEducationStage="parameters.education_stage_id = $event; setParameters()"
      />
    </div>
    <div class="col-sm-12 col-md-4">
      <GradeSelect
        :education-stage-id="parameters.education_stage_id"
        @setGrade="parameters.grade_id = $event; setParameters()"
      />
    </div>
    <div class="col-sm-12 col-md-4">
      <GradeVolumeSelect
        :grade-id="parameters.grade_id"
        @setGradeVolume="parameters.grade_volume_id = $event; setParameters()"
      />
    </div>
    <div class="col-sm-12 col-md-4">
      <GradeSubjectSelect
        :grade-id="parameters.grade_id"
        @setGradeSubject="parameters.grade_subject_id = $event; setParameters()"
      />
    </div>
    <div class="col-sm-12 col-md-4">
      <UnitSelect
        :grade-id="parameters.grade_id"
        :grade-subject-id="parameters.grade_subject_id"
        :grade-volume-id="parameters.grade_volume_id"
        @setUnit="parameters.unit_id = $event; setParameters()"
      />
    </div>
  </div>
</template>

<script>
import EducationSystemSelect from '@/components/contents/EducationSystemSelect.vue'
import EducationStageSelect from '@/components/contents/EducationStageSelect.vue'
import GradeSelect from '@/components/contents/GradeSelect.vue'
import GradeVolumeSelect from '@/components/contents/GradeVolumeSelect.vue'
import GradeSubjectSelect from '@/components/contents/GradeSubjectSelect.vue'
import UnitSelect from '@/components/contents/UnitSelect.vue'

export default {
  components: {
    EducationSystemSelect,
    EducationStageSelect,
    GradeSelect,
    GradeVolumeSelect,
    GradeSubjectSelect,
    UnitSelect
  },

  data: () => ({
    parameters: {
      education_system_id: null,
      education_stage_id: null,
      grade_id: null,
      grade_volume_id: null,
      grade_subject_id: null,
      unit_id: null
    }
  }),

  methods: {
    setParameters () {
      this.$emit('setParameters', this.parameters)
    }
  }
}
</script>
